// src/pages/Directions.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';

// Перенаправляем на страницу услуг, так как направления деятельности = услуги
export default function Directions() {
  return <Navigate to="/services" replace />;
}